<script>
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724591';

    export let product;
    export let brand = null;

    $: number = get_attribute_value(product, 'kw_mpn');
</script>

{#if product}
    <div class="product-header">
        <h1 class="h1 headline">
            {#if brand}<span>{brand.name}</span>{/if}
            {@html get_attribute_value(product, 'name')}
        </h1>
        {#if number}
            <div class="product-sku text-light">
                <span class="attribute_label h4">Art.Nr.:</span>
                <span>{number}</span>
            </div>
        {/if}
    </div>
{/if}
